module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-nano-all-02.9fb74eef.jpg";